import { useMutation } from "@apollo/client";
import { useModals } from "ModalProvider";
import { parseError } from "apollo";
import Button from "components/base/Button";
import { Alert } from "components/base/Toast";
import FactorySelector from "components/shared/FactorySelector";
import { useState } from "react";
import StockProductSelector from "./StockProductSelector";
import { ADD_PRODUCT_TO_STOCK } from "./graphql";

const AddProductToStockView = ({ hide, stock }) => {
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [useSupplierStock, setSupplierStock] = useState(true);
  const [supplierId, setSupplierId] = useState(null);
  const [addProductToStock, addProductToStockRes] = useMutation(
    ADD_PRODUCT_TO_STOCK,
    {
      variables: {
        stockId: stock.id,
        productId: selectedProduct?.id,
        useSupplierStock,
        supplierId,
      },
      onCompleted() {
        Alert("success", "Product is added to stock.");
        hide();
      },
      onError(error) {
        Alert("error", parseError(error));
      },
    },
  );

  const modal = useModals();

  const stockProductIds = stock.products.map((product) => product.id);
  const alreadyAdded = stockProductIds.includes(selectedProduct?.id);

  function tryChooseProduct() {
    modal.present({
      title: "Choose a Product",
      children: (
        <StockProductSelector
          onSelect={(product) => {
            setSelectedProduct(product);
            modal.hide();
          }}
        />
      ),
    });
  }

  return (
    <div>
      <div className="space-y-3">
        <div className="flex items-baseline space-x-3">
          <label>Product:</label>
          <div>
            {selectedProduct && (
              <div className="font-semibold">
                [{selectedProduct.number}] {selectedProduct.name}
              </div>
            )}

            <Button onClick={tryChooseProduct} className="mt-2">
              Choose Product
            </Button>
          </div>
        </div>

        <div>
          <div className="flex items-center space-x-3">
            <label htmlFor="useSupplierStock" className="cursor-pointer">
              Use Supplier Stock:{" "}
            </label>
            <input
              id="useSupplierStock"
              type="checkbox"
              checked={useSupplierStock}
              onChange={(e) => setSupplierStock(e.target.checked)}
            />
          </div>
        </div>

        {useSupplierStock && (
          <div>
            <label>Stock Supplier: </label>
            <FactorySelector value={supplierId} onChange={setSupplierId} />
          </div>
        )}
      </div>

      <hr />

      <div className="flex items-center space-x-4">
        <Button
          primary
          disabled={!selectedProduct || alreadyAdded}
          onClick={addProductToStock}
          loading={addProductToStockRes.loading}
        >
          Save
        </Button>
        {alreadyAdded && (
          <div className="text-red-600">Product already added to stock.</div>
        )}
      </div>
    </div>
  );
};

export default AddProductToStockView;
